import { useMutation } from '@tanstack/react-query'
import { getApiClient } from '../../stores'

export type TApiClient = ReturnType<typeof getApiClient>
type CheckHandleAvailability = Parameters<TApiClient['checkHandleAvailability']>[number]

export function useCheckWorkspaceHandleAvailability() {
  return useMutation({
    mutationFn: async ({ handle }: CheckHandleAvailability) => {
      return getApiClient()
        .checkHandleAvailability({ handle })
        .catch(() => ({ available: false, suggestions: [] }))
    },
  })
}
